import React from "react";
import { TextInput, usePermissions } from 'react-admin';
import { useForm, useFormState } from "react-final-form";

import { GridForm, GridInput } from '../../../components/GridForm';
import { PhoneInput, EmailInput } from '../../../components/inputs';
import { OSFCEmployeeTypeSelectInput } from '../../../components/inputs/EmployeeTypeSelect';
import { OperationalTerminalInput } from '../../../components/inputs/OperationalTerminalInput';
import { YesNoInput } from '../../../components/inputs/YesNoInput';
import { UserRole } from '../../../entities/UserRole';
import { canHaveOperationalTerminal, UserType } from '../../../entities/UserType';


export const ManagerCreateForm = props => {
	const { values } = useFormState();
	const { permissions } = usePermissions();
	const form = useForm();
	const showOperationalTerminal = canHaveOperationalTerminal({ type: values.type });
	const showCanEditCompletedOrder = values.type === UserType.app_manager && permissions?.role === UserRole.admin;

	const handleTypeChange = (event) => {
		if (event.target.value !== UserType.app_manager) {
			form.change("can_edit_completed_order", false);
		}
	};

	return (
		<GridForm {...props}>
			<GridInput sm={6} component={OSFCEmployeeTypeSelectInput} source="type" onChange={handleTypeChange} />
			<GridInput sm={6} component={YesNoInput} source="is_terminal" defaultValue={false} />
			<GridInput sm={6} component={YesNoInput} source="access_to_export" defaultValue={false} />
			<GridInput sm={6} component={YesNoInput} source="access_to_task_force" defaultValue={false} />
			{showCanEditCompletedOrder && <GridInput sm={6} component={YesNoInput} source="can_edit_completed_order" defaultValue={false} />}
			<GridInput sm={6} component={TextInput} source="first_name" autoFocus />
			<GridInput sm={6} component={TextInput} source="last_name" />
			<GridInput sm={6} component={PhoneInput} source="phone" />
			<GridInput sm={6} component={EmailInput} source="email" />
			<GridInput sm={6} component={TextInput} source="external_employee_id" />
			{showOperationalTerminal && <GridInput sm={6}>
				<OperationalTerminalInput />
			</GridInput>}
		</GridForm>
	);
};
